import * as Rest from "../../Generated/RestClient";
import {KuduClient} from "../../Services/KuduApi";
import {parseUrl} from "../../../../Intercom.ReactUI/Utils/Url";
import browserCaps from "../../../../Intercom.ReactUI/Utils/browserCaps";

// set to true to force we use server proxy to download zip file
// this should only be set to true when debug, as it forces us
// to add roundtrip between the browser and kudu endpoint
const debugZipProxy = false;

export function downloadBotSource(kuduClient: JQueryPromise<KuduClient>) : JQueryPromise<Blob> {
  let client: KuduClient = null;
  return kuduClient.then(kc => {
      // check if we have a prepareSrc script
      client = kc;
      let uri = parseUrl(client.scmUri.format());
      uri.path = '/api/vfs/site/wwwroot/PostDeployScripts/prepareSrc.cmd';
      return client.get(uri.format())
  })
  .then(cmd => {
      // found the script call it
      return client.command(`PostDeployScripts\\prepareSrc.cmd ${client.publishPassword}`, 'site\\wwwroot')
  })
  .then((f) => {
      // script finished, download the zip directly
      return client.download('site/bot-src.zip');
  })
  .then(null, () => {
      // something went wrong, try zip the the wwwroot folder
      if (client) {
          return client.zip('site/wwwroot/');
      } else {
          return $.Deferred().reject('could not access azure resource');
      }
  });
}

export function needZipProxy() : boolean {
    return (debugZipProxy || !browserCaps('a', 'download') && !navigator.msSaveBlob);
}

export function getBotZipBlobUrl(botId: string, url: string): string {
    let result: string = null;
    result = url;
    if (!result && botId && needZipProxy()) {
        result = `/api/botApp/${botId}/zip/${botId}.zip`;
    }
    return result;
}



// WEBPACK FOOTER //
// ./Client/v4/Services/downloadBotSrc.ts